import { createFileRoute } from '@tanstack/react-router'

import { OrganizationsDataGridPage } from '../../../components/pages/backoffice/organizations-data-grid-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/organizations/')({
  component: () => (
    <PermissionChecker requiredPermissions={['organization.read']}>
      <OrganizationsDataGridPage />
    </PermissionChecker>
  ),
})
